import { createAsyncThunk } from '@reduxjs/toolkit';
import favouriteService from './Favourite.service';
import { FavouriteServiceParams } from './Favourite.type';

export const addFavouriteThunk = createAsyncThunk(
  'employee/getEmployeeListThunk',
  async ({ personId }: FavouriteServiceParams) => {
    const response = await favouriteService.addFavourite({ personId });
    return response.data;
  },
);

export const deleteFromFavouriteThunk = createAsyncThunk(
  'employee/getEmployeeListThunk',
  async ({ personId }: FavouriteServiceParams) => {
    const response = await favouriteService.deleteFromFavourite({ personId });
    return response.data;
  },
);
